import { useCMSPageField } from '@/cms/fields'

import { getBrandName } from '@/scopes/common/infrastructure/analytics/brandNameMapper'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import { useCommonDependency } from '@/scopes/common/infrastructure/dependencies/common'
import { createAccoBasicDetailsEvent } from '@/scopes/products/infrastructure/analytics/index'
import * as React from 'react'

export function useSendAccoBasicDetails() {
  const { sendEvent } = useAnalytics()
  const productId = useCMSPageField('PDP.productId')
  const productName = useCMSPageField('PDP.title')
  const collectionName = useCMSPageField('PDP.collectionName')
  const accoStars = useCMSPageField('PDP.rating')
  const rating = useCMSPageField('userReviews.ratingAverage')
  const countryId = useCMSPageField('PDP.countryId')
  const regionId = useCMSPageField('PDP.regionId')
  const cityId = useCMSPageField('PDP.cityId')
  const countryName = useCMSPageField('PDP.countryName')
  const regionName = useCMSPageField('PDP.regionName')
  const cityName = useCMSPageField('PDP.cityName')
  const countryEnglishName = useCMSPageField('PDP.countryEnglishName')
  const regionEnglishName = useCMSPageField('PDP.regionEnglishName')
  const cityEnglishName = useCMSPageField('PDP.cityEnglishName')
  const brandName = useConfiguration('siteName')
  const sanitizedBrandName = getBrandName(brandName)

  const queryStringClient = useCommonDependency('queryStringClient')

  const sendAccoBasicDetailsEvent = React.useCallback(() => {
    const originList = queryStringClient.getValue('originList')

    sendEvent(
      createAccoBasicDetailsEvent({
        originList: originList || 'acco-page',
        countryName,
        regionName,
        cityName,
        accoStars: String(accoStars || ''),
        collections: collectionName || '',
        brand: sanitizedBrandName,
        cityId,
        countryId,
        id: productId,
        name: productName,
        rating: String(rating || ''),
        regionId,
        countryEnglishName,
        regionEnglishName,
        cityEnglishName,
      }),
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Only when the component mounts
  }, [])

  React.useEffect(() => {
    sendAccoBasicDetailsEvent()
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Only when the component mounts
  }, [])

  return {
    sendAccoBasicDetailsEvent,
  }
}
